module.exports = __webpack_public_path__ + "img/JacobPritchard.8193d1ff.jpg";